import { useState, type FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';

import { Alert, Box, Chip, SelectionListItem, Typography } from '@myn/mui';

import type { IOModalData } from '../../types/insertionOrder.js';

type Props = {
  text: string;
  data?: IOModalData | null;
  selectInsertionOrder: (itemId?: number | null) => void;
  alertData?: string;
};

const InsertionOrderIdList: FC<Props> = ({
  data,
  text,
  alertData,
  selectInsertionOrder,
}) => {
  const { t } = useTranslation('@myn/planning');

  const [radioChecked, setRadioChecked] = useState<number | null | undefined>();

  const updateSelectedRadio = (id?: number | null) => {
    setRadioChecked(id);
    selectInsertionOrder(id);
  };

  const handleToggleCheck = (id: number | null) => {
    const isCurrentChecked = radioChecked === id;

    if (isCurrentChecked) {
      updateSelectedRadio();
      return;
    }

    updateSelectedRadio(id);
  };

  return (
    <>
      <Typography variant="bodyLong01">{text}</Typography>
      {alertData && <Alert severity="info" title={alertData} sx={{ mt: 2 }} />}
      <Box mt={2}>
        {data?.ioData.map((item) => (
          <SelectionListItem
            key={item.ioId}
            text={item.name || t('New Insertion Order')}
            variant="radio"
            onClick={() => handleToggleCheck(item.ioId)}
            selected={radioChecked === item.ioId}
            sx={{ mb: 1 }}
            endAdornment={
              <Chip
                variant="outlined"
                label={item.ioId ? `ID: ${item.ioId}` : `${t('New')} ID`}
                color="transparent"
              />
            }
          />
        ))}
      </Box>
    </>
  );
};

export default InsertionOrderIdList;
